/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ShippingOrderAlertDetail {
  carrierName?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  hasResend?: boolean;
  lastTrackingStatus?: string;
  maxDeliveryDate?: Date;
  personEmail?: string;
  personId?: number;
  personName?: string;
  resendInvoiceNumber?: string;
  shippingOrderId?: number;
  trackingCode?: string;
}
